import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { useState, useEffect } from 'react';



// @mui
import {
  Card,
  Table,
  Stack,
  Button,

  TableRow,
  TableBody,
  TableCell,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  Box,
  CircularProgress,

} from '@mui/material';
import TextField from '@mui/material/TextField';

import Label from '../components/label';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
import CustomSnackBar from '../components/snackbar';
import MenuPopover from '../components/popover/menuPopover'
// sections
import { UserListHead } from '../sections/@dashboard/user';

// api
import RestaurantUserDialog from '../sections/dialogs/restaurantUserDialog';
import { listAdminUser, deleteAdminUser} from '../api/superadmin';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'name', label: 'Name', alignRight: false },
  { id: 'email', label: 'Email', alignRight: false },
  { id: 'role', label: 'Role', alignRight: false },
  { id: 'contact', label: 'Contact', alignRight: false },
  { id: 'adminStatus', label: 'Status', alignRight: false },
  { id: '' },
];
// ----------------------------------------------------------------------

export default function AdminList() {


  // snackbar
  const [snackbarOpen, setSnackbarOpen] = useState(false)
  const [snackbarMessage, setSnackbarMessage] = useState(null)

  const [adminUser, setAdminUser] = useState([]);
  const [filteredUser, setFilteredUser] = useState([]);

  const [isLoading, setIsLoading] = useState(false)

  const [selectedItem, setSelectedItem] = useState(false)

  const [dialogOpen, setDialogOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const [action, setAction] = useState('');

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');


  const [orderBy, setOrderBy] = useState('name');


  const [rowsPerPage, setRowsPerPage] = useState(10);



  const handleSearch = (event) => {
    const text = event.target.value;
    setFilteredUser(adminUser.filter((item) => `${item.firstName} ${item.lastName}`.toLowerCase().includes(text.toLowerCase())))
    // setFilteredUser(adminUser.filter((item) => item.firstName?.toLowerCase().includes(text.toLowerCase()) || item.lastName?.toLowerCase().includes(text.toLowerCase())))
  };

  const fetchData = async () => {
    setIsLoading(true)
    try {
      const { data } = await listAdminUser();

      console.log(data);
        setAdminUser(data.data.admins)
        setFilteredUser(data.data.admins)
      

      setIsLoading(false)
    }
    catch (e) {
      setIsLoading(false)
      // console.log({ e });
    }
  }

  // get admins list
  useEffect(() => {
    fetchData();
  }, []);


  const handleDelete = async (id) => {
    // console.log(id);
    try {
      const { data } = await deleteAdminUser(id);
      setMenuOpen(null)
      fetchData()
      setIsLoading(false)
      setSnackbarMessage({ msg: data.message, success: true });
      setSnackbarOpen(true);
    }
    catch (e) {
      setIsLoading(false)
      setSnackbarMessage({ msg: e.message, success: false });
      setSnackbarOpen(true);
    }
  }

  const handleOpenMenu = (event, item) => {
    // console.log(item);
    setSelectedItem(item)
    setMenuOpen(event.currentTarget);
  };

  // Dialog
  const handleDialogOpen = (item, str) => {

    if (item) {
      // console.log(item);
      setSelectedItem(item)
    }
    setAction(str)
    setDialogOpen(true);

  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };







  return (
    <>
      <Helmet>
        <title> Admin | RMS </title>
      </Helmet>

      <Box sx={{ height: '100%' }}>
        {!isLoading ? (
          <Box >
            <Stack>
              <Typography variant="h4" gutterBottom>
                Admin
              </Typography>
              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <TextField label='Search User' size='small' onChange={handleSearch} />
                <Button variant="contained" sx={{ backgroundColor: '#E0E082', color: '#000' }} startIcon={<Iconify icon="eva:plus-fill" />} onClick={() => handleDialogOpen(null, 'CREATE')}>
                  Add admin
                </Button>
              </Box>
            </Stack>


            <Card sx={{ mt: 2 }}>
              {/* <UserListToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} /> */}

              <Scrollbar>
                <TableContainer sx={{ minWidth: 800 }}>
                  <Table size='small'>
                    <UserListHead
                      order={order}
                      orderBy={orderBy}
                      headLabel={TABLE_HEAD}
                      onRequestSort={handleRequestSort}
                    />
                    <TableBody>
                      {filteredUser?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                        const { _id, firstName , lastName, email, roleName, contactNo, city, status } = row;
                        return (
                          <TableRow hover key={_id} tabIndex={-1} role="checkbox" sx={{ border: '1px solid #87E1AD' }}>

                            <TableCell component="th" >

                              {firstName} {lastName}
                            </TableCell>


                            <TableCell align="left">{email}</TableCell>
                            <TableCell align="left">{roleName} </TableCell>
                            <TableCell align="left">{contactNo} </TableCell>
                            <TableCell align="left">{status}</TableCell>
                            

                            <TableCell align="right">
                              <IconButton size="large" color="inherit" onClick={(e) => handleOpenMenu(e, row)}>
                                <Iconify icon={'eva:more-vertical-fill'} />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        );
                      })}

                    </TableBody>

                  </Table>
                </TableContainer>

              </Scrollbar>

              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={filteredUser?.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Card>
          </Box>
        ) : (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}> <CircularProgress /> </Box>
        )}
      </Box>
      {dialogOpen && <RestaurantUserDialog fetchData={fetchData} dialogOpen={dialogOpen} setDialogOpen={setDialogOpen} setAdminUser={setAdminUser} setFilteredUser={setFilteredUser} setSnackbarMessage={setSnackbarMessage} setSnackbarOpen={setSnackbarOpen} selectedItem={selectedItem} action={action} />}
      <CustomSnackBar snackbarOpen={snackbarOpen} setSnackbarOpen={setSnackbarOpen} snackbarMessage={snackbarMessage && snackbarMessage.msg} success={snackbarMessage && snackbarMessage.success} />
      <MenuPopover menuOpen={menuOpen} setMenuOpen={setMenuOpen} handleDialogOpen={handleDialogOpen} handleDelete={handleDelete} handleSuspend={''} selectedItem={selectedItem} from='adminUserList' />
    </>
  );
}
